import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const videoAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: false, max: 80 },
  { name: 'subheadline', type: 'string', required: false, max: 200 },
  {
    name: 'videos',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'title', type: 'string', required: true, max: 60 },
      { name: 'description', type: 'string', required: false, max: 160 },
      { name: 'poster', type: 'image_url', required: false },
      { name: 'videoUrl', type: 'url', required: false },
      { name: 'duration', type: 'string', required: false, max: 12 },
    ],
  },
];

export const videoUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', max: 80 },
  { name: 'subheadline', type: 'textarea', label: 'Subheadline', max: 200 },
  { name: 'videos', type: 'video_list', label: 'Videos', required: true },
];

export const videoZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().max(80).optional().nullable(),
  subheadline: z.string().max(200).optional().nullable(),
  videos: z
    .array(
      z.object({
        title: z.string().max(60),
        description: z.string().max(160).optional().nullable(),
        poster: z.string().optional().nullable(),
        videoUrl: z.string().optional().nullable(),
        videoSource: z.enum(['firebase', 'youtube', 'vimeo']).optional().nullable(),
        duration: z.string().max(12).optional().nullable(),
      }),
    )
    .min(1),
});

export type VideoContent = z.infer<typeof videoZodSchema>;

export const videoSample: VideoContent = {
  eyebrow: 'Watch',
  headline: 'See it in motion',
  subheadline: 'A 90-second walkthrough of the entire workflow.',
  videos: [
    {
      title: 'Product overview',
      description: 'A guided tour from setup to first deployment.',
      poster: null,
      videoUrl: null,
      duration: '1:32',
    },
    {
      title: 'Customer story: Acme',
      description: 'How Acme cut review time by 60%.',
      poster: null,
      videoUrl: null,
      duration: '2:48',
    },
    {
      title: 'Founder talk',
      description: 'Why we built this.',
      poster: null,
      videoUrl: null,
      duration: '4:10',
    },
  ],
};
